import ButtonCTA from './ButtonCTA';

const buttonCTAConfig = {
  name: 'buttonCTA',
  class: ButtonCTA,
};

export default buttonCTAConfig;



// WEBPACK FOOTER //
// ./client/js/components/ButtonCTA/buttonCTAConfig.js